import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import { useTranslation } from "react-i18next";

const markdownComponents = {
  h1: ({ children }) => <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-2">{children}</h1>,
  h3: ({ children }) => <h3 className="font-heading text-lg font-bold mt-8 mb-2 text-[#2B2B2B]">{children}</h3>,
  p: ({ children }) => <p className="text-sm text-[#2B2B2B]/80 leading-relaxed mb-3">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 text-sm text-[#2B2B2B]/80 leading-relaxed mb-3 space-y-1">{children}</ul>,
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-[#2B2B2B]">{children}</strong>,
  a: ({ children, href }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#4ba3b7] hover:underline">{children}</a>,
};

/** Renders a static legal document (Markdown source) with the app's typographic styles. */
export default function LegalPageLayout({ content, testId }) {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 py-10 sm:py-14" data-testid={testId}>
      <p className="text-xs uppercase tracking-wide text-[#4ba3b7] font-bold mb-4">{t("legal.frenchOnlyNotice")}</p>
      <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 sm:p-10">
        <ReactMarkdown remarkPlugins={[remarkBreaks]} components={markdownComponents}>{content}</ReactMarkdown>
      </div>
    </div>
  );
}
